const getImageSize = async (file: File): Promise<{ width: number; height: number }> => {
  let imageSize: { width: number; height: number };
  const imageUrl = URL.createObjectURL(file);

  try {
    imageSize = await new Promise<{ width: number; height: number }>((resolve, reject) => {
      const image = new Image();
      image.src = imageUrl;
      image.addEventListener('load', () => resolve({ width: image.width, height: image.height }));
      image.addEventListener('error', error => reject(error));
    });
  } finally {
    URL.revokeObjectURL(imageUrl);
  }

  return imageSize;
};

export default getImageSize;
